import axios from 'axios'
import create from 'zustand'

const uploadStore = (set: any) => ({
  activeStep: -1,
  categoryList: [],
  currentCategory: undefined,
  uploadAssetId: '',
  setActiveStep: (step: any) =>
    set((state: any) => ({
      activeStep: step,
    })),
  getCategoryList: () => {
    axios
      .get(
        'https://us-central1-test-69192.cloudfunctions.net/assets/categories'
      )
      .then((res: any) => {
        set((state: any) => ({
          categoryList: [
            {
              name: 'All Categories',
              key: 'all',
              description: ['Select all categories'],
            },
            ...res.data.data,
          ],
        }))
      })
      .catch((e: any) => {
        // console.log(e)
      })
  },
  setCurrentCategory: (category: any) =>
    set((state: any) => ({
      currentCategory: category,
    })),
  setUploadAssetId: (id: any) => {
    return set((state: any) => ({
      uploadAssetId: id,
    }))
  }
})

const useUploadStore = create(
  // devtools(
  //     persist(uploadStore, {
  //         name: "upload"
  //     })
  // ),
  uploadStore
)

export default useUploadStore
